import React from "react";

function InputDatoProdotto({permessoScrittura, inputLabel,tipoInput,tabName,checked,datoName,datoId,datoValue,datoPlaceHolder,datoOnChange,datoClass,inputClass,labelClass,classiTastoSblocco,tastoCopiaAspetto,modCompatta,tastiPredefiniti,tooltip,min}) {
        
    let tipo = "text"

    if (tipoInput) {
        tipo = tipoInput
    }
     
    if (permessoScrittura === "NO") {
        return(
            <p className={datoClass}><strong>{inputLabel}: </strong>{datoValue}</p>
        )
    } else {
        
        if (modCompatta === "SI") {
            return(
                <div className={datoClass+" flex items-center mb2"}>
                    <div for={datoId}
                        className={labelClass+" pointer mr2 labInp"} 
                        onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
                    >{inputLabel}</div>{tooltip && <span className="ml1 gray pointer" title={tooltip} aria-label={tooltip}>ⓘ</span>}
                                <input
                                    min={min}
                                    type={tipo}
                                    id={datoId}
                                    checked={checked}
                                    placeholder={datoPlaceHolder}
                                    name={datoName}
                                    value={datoValue}
                                    autoComplete="off"
                                    onChange={datoOnChange}
                                    className={inputClass}
                                />                        
                    {tastoCopiaAspetto !== "NO" && <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button>}
                    
                </div>
            )
        } else {
            return (
                <div className="mb1">
                    <label for={datoId}
                        className="pointer" 
                        onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())}
                    >{inputLabel}</label>{tooltip && <span className="ml1 gray pointer" title={tooltip} aria-label={tooltip}>ⓘ</span>}<br />
                                <input
                                    min={min}
                                    type={tipo}
                                    id={datoId}
                                    placeholder={datoPlaceHolder}
                                    checked={checked}
                                    name={datoName}
                                    value={datoValue}
                                    autoComplete="off"
                                    onChange={datoOnChange}
                                    className={datoClass}
                                />                        
                    {tastoCopiaAspetto !== "NO" && <button onClick={(e) => navigator.clipboard.writeText(datoValue).then(e.preventDefault())} className={classiTastoSblocco}>{tastoCopiaAspetto}</button>}
                    <br />  
                    {tastiPredefiniti && <div className="mb3">{tastiPredefiniti.map(tasto => {
                    return <button 
                        id={datoId}
                        name={datoName}
                        value={tasto}
                        onClick={datoOnChange}
                        className="tastoBianco f6-ns link dim ba ph3 pv2 dib br3 bordoColAlt mr2 pointer"
                        >
                        {tasto}
                        </button>
                        
                    })}
                    </div>
                    }
                </div>
            )
        }
    }
    
}

export default InputDatoProdotto;